import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ProgressSearch',
})
export class ProgressSearchPipe implements PipeTransform {
  constructor() {}

  transform(item: any): any {
    const webbitPrice = item.webbitPrice;
    const waiterPrice = item.waiterPrice;
    const price = item.price;

    const tmp = () => {
      switch (item.type) {
        case '웨이터':
          return waiterPrice;
        case '웨빗':
          return webbitPrice;
        case '거래취소':
          return webbitPrice;
        case '관리자차감':
          return webbitPrice;
        case '이벤트':
          return webbitPrice;
        case '요청취소':
          return webbitPrice;
        case '신고처리':
          return webbitPrice;
        case '관리자지급':
          return webbitPrice;
        case '인출요청':
          return price;
        case '포인트구매':
          return price;
        case '환불요청':
          return price;
      }
    };
    return tmp();
  }
}
